// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-53d69c1a]{height:100%;display:flex;flex-direction:column}.select-commonly-place[data-v-53d69c1a] .popup-content{padding:0}.select-commonly-place[data-v-53d69c1a] .uni-scroll-view-content{display:flex;flex-direction:column}.position-top[data-v-53d69c1a] :deep(.container.popup-container){height:calc(90vh - %?88?%)}", ""]);
// Exports
module.exports = exports;
